// extracted by mini-css-extract-plugin
module.exports = {"page":"layout_page__2Rjuu","main":"layout_main__DItFU","header":"layout_header__1WuJA"};